import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollectionLayer } from '@adornis/baseql/server/collections.js';
import { AdornisUser } from '@adornis/users/db/a-user.js';
import { ExpectedError } from '@adornis/validation/errors/ExpectedError.js';
import { assertCanManageUsers } from '../server/access.js';
import { terminateSessionsForUser } from '../server/terminateSessions.js';

/**
 * Deactivate or reactivate. The engine does not enforce `archivedAt` anywhere: logging in
 * is blocked by passwordFlow's validateUser (server/startup.ts), and sessions that already
 * exist are ended here — otherwise an open tab would stay usable indefinitely.
 */
export const setUserArchived = registerMutation({
  type: () => Boolean,
  operationName: 'setUserArchived',
  resolve: (userID: string, archived: boolean) => {
    return async () => {
      const callerID = await assertCanManageUsers();
      if (userID === callerID) throw new ExpectedError('Du kannst dein eigenes Konto nicht deaktivieren.');

      const users = await getCollectionLayer<AdornisUser>(AdornisUser._collectionName);
      const result = await users.updateOne(
        { _id: userID },
        archived ? { $set: { archivedAt: new Date() } } : { $unset: { archivedAt: '' } },
      );
      if (result.matchedCount === 0) throw new ExpectedError('Dieses Konto existiert nicht (mehr).');

      if (archived) await terminateSessionsForUser(userID);
      return archived;
    };
  },
  params: [
    { name: 'userID', type: () => String },
    { name: 'archived', type: () => Boolean },
  ],
});
